import { TextureLoader,VideoTexture } from 'three'
import * as _ from 'underscore'
import { LHFEventDispatcher } from '../../com/LHFEventDispatcher'
import { PanoEvent } from '../events/PanoEvents'
import { PanoAni } from './PanoAni'
import { SpriteMarkerMana } from './SpriteMarkerMana'
import {createPureVideoTexture} from "./utils";

/**
 * 场景切换
 */
class PanoSwitch extends LHFEventDispatcher {
  constructor(sceneData_, material_, renderMain_, camera_, dom_, scene_) {
    super()
    this.renderMain = renderMain_
    this.camera = camera_
    this.dom = dom_
    this.scene = scene_
    this.sceneData = sceneData_
    this.curSceneData = null;
    this.material = material_
    this.init()
  }
  init() {
    this.textureLoader = new TextureLoader()
    // 全景动画
    this.panoAni = new PanoAni(this.scene)
    // 标记管理
    this.spriteMana = new SpriteMarkerMana(this.scene, this.camera, this.dom)
    this.spriteMana.addEventListener(PanoEvent.SCENE_CHANGE, event => {
      this.sceneChangeHandler(event)
    })
    // 使用默认场景
    this.changeScene(this.sceneData.default)
  }

  /**
   * 场景更改
   * @param {object} event
   */
  sceneChangeHandler(event) {
    /**     * 开始场景切换动画     */
    this.renderMain.switchAniStart().then(() => {
      /**       * 切换场景       */
      this.changeScene(event.data)
    })
  }

  /**
   * 刷新
   * @param {number} delta_
   */
  update(delta_) {
    this.spriteMana.update(delta_)
  }
  /**
   * 更改场景
   * @param {string} id_
   */
  changeScene(id_) {
    let sceneData = _.find(this.sceneData.scene, { id: id_ })
    if (sceneData) {
      this.curSceneData = sceneData;
      this.loadPanoTexture(sceneData.texture)
      // 切换场景全景动画
      this.panoAni.setCurPano(sceneData)
      // 切换场景标记
      this.spriteMana.setCurPano(sceneData)
    }
  }
  /**
   * 加载全景素材
   * @param {string} url_
   */
  loadPanoTexture(url_) {
    let videoDom = document.getElementById("videoID")
    // console.log(videoDom)
    var texture = new VideoTexture(videoDom)
    texture.needsUpdate = true
    this.material.map = texture
    // if(this.curSceneData.texture_type == 'video'){
    //   //texture = createPureVideoTexture(url_)
    //
    // }else {
    //   texture = this.textureLoader.load(url_)
    // }
  }
}
export { PanoSwitch }



// WEBPACK FOOTER //
// ./src/webgl/panorama/PanoSwitch.js